<template>
	<div class="wrap">
		<el-row class="tag color-orange" v-if="!showAll">
					<el-col :span="18" class="tag_text">
						<i class="el-icon-circle-close"></i>
						未完成此患者的中医评估，无法自动生成中医处方，请前去完成评估
					</el-col>
					<el-col :span="6" class="tag_text tag_text_right">
						<!-- <a @click="onEvalShow(sideEvalList)" class="goto">去评估</a> -->
					</el-col>
				</el-row>
		<template v-if='showAll'>
			<div v-if="isShow">
				<el-row class="tag color-grey" v-if="tag && !hidden && !isSave">
					<el-col :span="18" class="tag_text">
						<i class="el-icon-info"></i>
						已完成对患者的中医评估，自动生成中医处方，请医生确认后发布
					</el-col>
					<el-col :span="6" class="tag_text tag_text_right">
						<a @click="isHidden" class="know">我知道了</a>
					</el-col>
				</el-row>
				
			</div>
			<el-form ref="form" :model="form" :rules="rules" label-width="80px">
				<div id="medicine" class="body">
					<div class="item">
						<h2 class="cf">中医处方</h2>
					</div>
					<div v-show="tag" class="item">
						<div class="title">
							评估结果
						<el-button class="exportPdf" v-if="!showSaveBtn" :loading="isLoading" @click="exportPdf">导出处方</el-button>
							
						</div>
						<div class="text">
							中医体质为：
							<span style="color: #73B5BB;">{{form.result}}</span>
						</div>
					</div>
					<div v-for="(item,index) in form.content" v-bind:key="index">
						<div class="mTop10">
							<div class="title">
								{{item.type}}处方内容
							</div>
							<div>
								<div v-show="!isSave">
									<div v-for="(item2, index2) in item.content" v-bind:key="index2">
										<div class="m20">
											<div class="sx"></div>{{item2.name}}
										</div>
										<div class="tips">
											{{item2.reading}}
										</div>
										<div>
											<el-form-item label="" prop="content.living" label-width="0">
												<el-input type="textarea" placeholder="请输入处方内容"
													v-model="item2.prescription" :rows="3"></el-input>
											</el-form-item>
											<div v-if="item2.instructions" class="m40">
												<img :src="item2.instructions.picUrl" class="img" />
												<span class="url_text">{{item2.instructions.desc}}</span>
											</div>
										</div>
									</div>
								</div> 

								<div v-show="isSave">
									<div v-for="(item2, index2) in item.content" v-bind:key="index2">
										<div class="m20">
											<div class="sx"></div>{{item2.name}}
										</div>
										<div class="tips">
											{{item2.reading}}
										</div>
										<div class="desc">{{item2.prescription}}</div>
										<div v-if="item2.instructions" class="m40">
											<img :src="item2.instructions.picUrl" class="img" />
											<span class="url_text">{{item2.instructions.desc}}</span>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<el-row class="dealwith">
						<el-col :span="12"  v-if="!showSaveBtn">
							责任医师：{{form.name}}<br/>
							发布时间：{{form.time}}
						</el-col>
						<el-col :span="12" class="tag_text_right" v-if="prescriptionItem &&prescriptionItem.hospitalChineseMedicineVO?.pushTime">
							推送时间：{{prescriptionItem.hospitalChineseMedicineVO?.pushTime}}
						</el-col>
					</el-row>
				</div>
				
				<div id="medicine_print" class="body hide">
					<div class="item">
						<h2 class="cf">中医处方</h2>
					</div>
					<div style="color: #333;font-weight: normal;margin:16px 0;text-align: center;">姓名：{{ medicalRecordDetail.patientName}}&nbsp;&nbsp;&nbsp;&nbsp;科室：{{ medicalRecordDetail.department}}&nbsp;&nbsp;&nbsp;&nbsp;床号：{{medicalRecordDetail.inpatientArea}}-{{ medicalRecordDetail.hospitalBed}}床</div>
					<div v-show="tag" class="item">
						<div class="title">
							评估结果

						</div>
						<div class="text">
							中医体质为：
							<span style="color: #73B5BB;">{{form.result}}</span>
						</div>
					</div>
					<div v-for="(item,index) in form.content" v-bind:key="index">
						<div class="mTop10">
							<div class="title item">
								{{item.type}}处方内容
							</div>
							<div class="item" v-for="(item2, index2) in item.content" v-bind:key="index2">
								<div class="m20">
									<div class="sx"></div>{{item2.name}}
								</div>
								<div class="tips">
									{{item2.reading}}
								</div>
								<div class="desc">{{item2.prescription}}</div>
								<div v-if="item2.instructions" class="m40">
									<img :src="item2.instructions.picUrl" class="img" />
									<span class="url_text">{{item2.instructions.desc}}</span>
								</div>
							</div>
						</div>
					</div>
					<el-row class="dealwith">
						<el-col :span="12">
							责任医师：{{form.name}}
						</el-col>
						<el-col :span="12" class="tag_text_right">
							发布时间：{{form.time}}
						</el-col>
					</el-row>
				</div>			
				<div v-show="isShow">
					<div class="save" v-if="showSaveBtn">
						<el-button type="primary" :loading="isLoading" @click="save('form')">发 布</el-button>
					</div>
					<div class="save" v-if="!showSaveBtn">
						<el-popconfirm confirmButtonText='删除' title="确定删除处方吗？" @confirm="delPrescription">
							
							<el-button slot="reference" style="float: left;" type="danger" :loading="isLoading" >删除处方</el-button>
						</el-popconfirm>

						<el-button type="primary" :loading="isLoading" @click="update">修改处方</el-button>
						<el-button :loading="isLoading" @click="dialogVisible=true" v-if="patientInfo.wxBindingState == 1">推送处方</el-button>
						<span style="opacity: 0;">{{ this.prescriptionItem.hospitalChineseMedicineVO.id}}</span>
					</div>
				</div>
			</el-form>
		</template>

					
			
		<SendDialog v-if="dialogVisible" :dialogVisible.sync="dialogVisible" type="6"  :prescriptionId="prescriptionItem.hospitalChineseMedicineVO.id"/>

	</div>
</template>

<script>
	import api from '@/service/api.js';
	import htmlToPdf from '@/service/htmlToPdf'
	import SendDialog from './sendDialog.vue';

	export default {
		components: {
			SendDialog
		},
		props: {
			patientInfo:{
				required: true
			},
			recordId: {
				required: true
			},
			patientId: {
				required: true
			},
			datasources: {
				// required: true
				default: null

			},
			onEvalShow: {
				type: Function,
				default: null
			},
			isShow:{
				type:Boolean,
				default: true
			},
			sideEvalList:{
				// required: true
				default: null

			},
			medicalRecordDetail:{
				// required:true
				default: null

			},

		},
		data() {
			return {
				tag: true,
				hidden: false,
				form: {
					content: [
						{
							type: "",
							content: [
								{
									reading: "古人云，起居有常能形与神俱，尽终天年、度百岁。根据体质特点合理安排作息是日常调养的重要方法。",
									prescription: "",
									name: "起居注意"
								},
								{
									reading: "食物可分为酸、苦、甘、辛、咸五味和寒、热、温、凉四性。根据不同体质选择适宜的食物调理身体可起到事半功倍的效果。",
									prescription: "",
									name: "饮食宜忌"
								},
								{
									reading: "运动是体质调理和养生的重要方法，但在运动前应做《运动风险评估》，如提示有运动风险应咨询医生，避免运动强度过大发生不良事件。",
									prescription: "",
									name: "运动调理"
								},
								{
									reading: "相由心生、病由心生。七情过极可导致人体气机紊乱，脏腑阴阳气血失调。调节和疏导情绪，平和心态，是体质调理和疾病康复的重要法则。",
									prescription: "",
									name: "情志疏导"
								},
								{
									reading: "经络是人体气血运行的通路，调气血先要调经络。",
									prescription: "",
									name: "经络调理"
								},
								{
									reading: "不同体质有不同的患病倾向，应定期检查和关注可能出现问题的指标，及时发现疾病征兆。您的体质特点需重点关注以下指标：",
									prescription: "",
									name: "指标关注"
								}
							]
						}
					],
					result: "",
					name: "",
					time: "",
				},
				isLoading: false,
				showSaveBtn: true,
				readonly: false,
				isSave: false,
				saveStyle: "",
				rules: {
				},
				dialogVisible:false,
				showAll:false,

			}
		},
		async created(){
			let query=this.$route.query;
			if(Number(query.datasources)!=1&&Number(query.datasources)!=2){
				let res=await api.checkPreVisibleTypes({
					recordId:this.recordId,
					type:6
				})
				this.showAll=res.data;
			}else{
				this.showAll=true
			}
		},
		methods: {
			async init(prescriptionItem) {
				this.prescriptionItem = prescriptionItem;
				if (this.prescriptionItem.hospitalChineseMedicineVO.evalResult != null) {
					let evalResult = JSON.parse(this.prescriptionItem.hospitalChineseMedicineVO.evalResult);
					if (evalResult.evalError == "") {
						let evalContent = evalResult.evalContent;
						this.tag = true;
						if (this.prescriptionItem.hospitalChineseMedicineVO.content == null) {
							this.form.result = evalResult.evalContent // 评估结果
							this.form.content = evalResult.prescription // 处方内容
						}
						
					} else {
						this.tag = false;
					}
				} else {
					this.tag = false;
				}
				
				if (this.prescriptionItem.hospitalChineseMedicineVO.content != null) {
					this.hidden = true;
					let content = JSON.parse(this.prescriptionItem.hospitalChineseMedicineVO.content);
					if(content && content.result[0] != '' && content.result != null){
						this.tag = true;
					}
					this.form = content;
					this.showSaveBtn = false;
					this.isSave = true;
				}
			},
			save(formName) {
				this.$refs[formName].validate(async (valid) => {
					if (valid) {
						this.isLoading = true;
						let user = JSON.parse(localStorage.getItem("user"));
						let myDate = new Date();
						let time = myDate.getFullYear() + "/" + (myDate.getMonth() + 1) + "/" + myDate
							.getDate() + " " +
							myDate.toLocaleTimeString();
						let data = [];
						data.push({
							"content": JSON.stringify({
								result: this.form.result,
								content:this.form.content,
								name: user.data.name,
								time: time
							}),
							"datasources": this.datasources,
							"patientId": this.patientId,
							"prescriptionType": 6,
							"recordId": this.recordId,
							"state": 1
						});
						let res = await api.addPrescription(data);
						this.isLoading = false;
						if (res.code != 1000) {
							return this.$message.error(res.message);
						}
						this.showSaveBtn = false;
						this.isSave = true;

						this.form = {
							result: this.form.result,
							content: this.form.content,
							name: user.data.name,
							time: time
						}
						this.$emit('trigger-event',6);
					}
				});
			},
			update() {
				this.showSaveBtn = true;
				this.isSave = false;
				this.prescriptionItem.hospitalChineseMedicineVO.pushTime=null

			},
			exportPdf() {
				htmlToPdf.outPutPdfFn(document.querySelector("#medicine_print"), "中医处方");
			},
			isHidden() {
				this.hidden = true;
			},
			async delPrescription(){
				let res=await api.delPrescription({
					id:this.prescriptionItem.hospitalChineseMedicineVO.id,
					prescriptionType:6
				})
				if (res.code != 1000) {
					return this.$message.error(res.message);
				}
				this.showSaveBtn = true;
				this.isSave = false;

				this.prescriptionItem.hospitalChineseMedicineVO.content = null;
				this.init(this.prescriptionItem)
				this.$emit('trigger-event',6);

			}
		}
	}
</script>

<style lang="less" scoped>
.wrap{
	min-height: 300px;
}

	.body {
		padding: 20px 120px;
		font-size: 20px;
		color: #409EFF;
	}
	.exportPdf{
		float: right;
		margin-top: -18px;
		background: #fff;
		color: #699ce4;
		border-radius: 20px;
		padding: 6px 12px;
	}
	.title {
		border-bottom: 3px solid #409EFF;
		margin: 24px 0;
	}

	.save {
		text-align: right;
		padding: 20px 120px;
		margin-bottom: 30px;
	}

	.dealwith {
		color: #333333;
		font-size: 14px;
		padding-top: 20px;
	}

	.saveText {
		background-color: #EFF8FE;
		border-color: #409EFF;
	}

	.text {
		font-size: 14px;
		margin: 15px 0;
		color: #333333;
	}

	.tag {
		border-radius: 5px;
		height: 35px;
		margin: 0 30px;
		padding: 0 15px;
		font-size: 13px;
	}

	.color-grey {
		background-color: #E6E6E6;
		color: #4D4D4D;
	}

	.color-orange {
		background-color: #FFECEC;
		color: #FF5D5D;
	}

	.topic {
		background-color: #CFEAFC;
	}

	.sx {
		width: 5px;
		background-color: #409EFF;
		height: 22px;
		border-radius: 5px;
		float: left;
		margin-right: 10px;
		margin-top: 3px;
	}

	.desc {
		border-radius: 5px;
		border: 1px solid #409EFF;
		background-color: #EFF8FE;
		margin: 30px 0;
		padding: 20px;
		font-size: 14px;
		color: #333333;
		line-height: 30px;
		white-space: pre-line;
	}

	.desc1 {
		background-color: #fff;
		border: 1px solid #E6E6E6;
	}

	.tips {
		color: #4D4D4D;
		font-size: 14px;
		margin-bottom: 20px;
	}

	.el-form .el-textarea {
		width: 100%;
		font-size: 14px;
		border-radius: 5px;
		resize: none;
		outline: none;
		line-height: 30px;
	}
	
	textarea{
		min-height: 150px;
		font-size: 14px;
	}

	.url_text {
		font-size: 14px;
		color: rgb(97, 97, 97);
		margin-top: -75px;
		margin-left: 190px;
		padding-bottom: 20px;
		display: block;
	}
	
	.know{
		color: #4D4D4D;
		cursor: pointer;
	}
	
	.goto{
		color: #FF5D5D;
		cursor: pointer;
	}
	
	.tag_text {
		line-height: 35px;
		font-size: 14px;
	}
	
	.tag_text_right {
		text-align: right;
	}
	
	.tag_text_center {
		text-align: center;
	}
	
	.title {
		border-bottom: 3px solid #409EFF;
		margin-bottom: 20px;
		font-size: 20px;
	}
	
	.cf {
		font-size: 24px;
		text-align: center;
		color: #333333
	}
	
	.mTop10 {
		margin-top: 10px;
	}
	
	.m20 {
		margin: 20px 0;
		font-size: 20px;
	}
	
	.table{
		text-align: center;
		font-size: 14px;
		color: #333333;
		width: 100%;
	}
	
	.m40{
		margin: 40px 0;
	}
	
	.img{
		width: 128px;
	}
	
	#medicine_print{
		.body {
			padding: 20px 120px;
			font-size: 18px;
			color: #409EFF;
		}
		
		.title {
			border-bottom: 3px solid #409EFF;
			margin-bottom: 20px;
		}
		
		
		.save {
			text-align: right;
			padding: 20px 120px;
		}
		
		.dealwith {
			color: #000;
			font-size: 16px;
			padding-top: 20px;
		}
		
		.saveText {
			background-color: #EFF8FE;
			border-color: #409EFF;
		}
		
		.tips {
			color: #4D4D4D;
			font-size: 16px;
			margin-bottom: 20px;
		}
		
		.text {
			font-size: 24px;
			margin: 15px 0;
			color: #000;
		}
		
		.tag {
			border-radius: 5px;
			height: 35px;
			margin: 0 30px;
			padding: 0 15px;
			font-size: 16px;
		}
		
		.h20{
			height: 20px;
		}
		
		.color-grey {
			background-color: #E6E6E6;
			color: #4D4D4D;
		}
		
		.color-orange {
			background-color: #FEF8DE;
			color: #EEC211;
		}
		
		table {
			border: 1px solid #4D4D4D;
			border-collapse: collapse;
			border-spacing: 0;
		}
		
		table th {
			height: 40px;
			border: 1px solid #4D4D4D;
		}
		
		table td {
			padding: 10px;
			height: 20px;
			border: 1px solid #4D4D4D;
			width: 25%;
		}
		
		.table{
			text-align: center;
			font-size: 17px;
			color: #333333;
			width: 100%;
		}
		
		.topic {
			background-color: #CFEAFC;
		}
		
		.sx {
			width: 5px;
			background-color: #409EFF;
			height: 25px;
			border-radius: 5px;
			float: left;
			margin-right: 10px;
			margin-top: 3px;
		}
		
		.el-form .el-input:not(.el-transfer-panel__filter){
			width: 60%;height: 30px;
		}
		
		.desc {
			border-radius: 5px;
			border: 1px solid #409EFF;
			background-color: #EFF8FE;
			margin: 30px 0;
			padding: 20px 20px 20px 40px;
			font-size: 18px;
			color: #000;
			line-height: 40px;
		}
		
		/deep/.el-form-item__content{
			margin-top: 18px;
		}
		
		/deep/.el-form-item__error {
			margin-left: 40%;
		}
		
		.text_dec{
			text-align: left;
			padding-left: 5px;
			line-height: 40px;
			margin-top: 18px
		}
		
		.know{
			color: #4D4D4D;
			cursor: pointer;
		}
		
		.goto{
			color: #EEC211;
			cursor: pointer;
		}
		
		.tag_text {
			line-height: 35px;
			font-size: 18px;
		}
		
		.tag_text_right {
			text-align: right;
		}
		
		.title {
			border-bottom: 3px solid #409EFF;
			margin-bottom: 20px;
			font-size: 26px;
		}
		
		.cf {
			font-size: 30px;
			text-align: center;
			color: #000
		}
		
		.mTop10 {
			margin-top: 10px;
		}
		
		.m20 {
			margin: 40px 0;
			font-size: 22px;
		}
		
	}
	
	
	.hide{
		position: absolute;
		z-index: -999;
	}
</style>
